import { createApi } from '@reduxjs/toolkit/query/react';
import {
  PromotionDurationsResponse,
  GetPromotionDurationsParams,
  CreatePromotionDurationRequest,
  UpdatePromotionDurationRequest,
} from '../../types/promotionDurations';
import { baseQueryWithReauth } from './baseQuery';

export const promotionDurationsService = createApi({
  reducerPath: 'promotionDurationsService',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['PROMOTION_DURATIONS'],
  endpoints: (builder) => ({
    getPromotionDurations: builder.query<
      PromotionDurationsResponse,
      GetPromotionDurationsParams
    >({
      query: (params) => ({
        url: '/marketplace-service/v1/operator/promotion-durations',
        method: 'GET',
        params,
      }),
      providesTags: ['PROMOTION_DURATIONS'],
    }),

    createPromotionDuration: builder.mutation<
      { payload?: any; success?: boolean; message?: string },
      CreatePromotionDurationRequest
    >({
      query: (body) => ({
        url: '/marketplace-service/v1/operator/promotion-durations',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PROMOTION_DURATIONS'],
    }),

    updatePromotionDuration: builder.mutation<
      { payload?: any; success?: boolean; message?: string },
      UpdatePromotionDurationRequest
    >({
      query: ({ id, body }) => ({
        url: `/marketplace-service/v1/operator/promotion-durations/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['PROMOTION_DURATIONS'],
    }),

    deletePromotionDuration: builder.mutation<
      { payload?: any; success?: boolean; message?: string },
      string
    >({
      query: (id) => ({
        url: `/marketplace-service/v1/operator/promotion-durations/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PROMOTION_DURATIONS'],
    }),
  }),
});

export const {
  useGetPromotionDurationsQuery,
  useCreatePromotionDurationMutation,
  useUpdatePromotionDurationMutation,
  useDeletePromotionDurationMutation,
} = promotionDurationsService;
